/* Shelf genres, in the order the filter lists them. A book names one of these
   ids in its `genre` field; a genre with no books is left out of the menu. */
export const genres = [
  { id: 'engineering', label: 'Engineering' },
  { id: 'focus', label: 'Habits & focus' },
  { id: 'mind', label: 'Mind & money' },
  { id: 'business', label: 'Business' },
  { id: 'lives', label: 'Lives' },
  { id: 'investigations', label: 'Investigations' },
  { id: 'fiction', label: 'Fiction' },
  { id: 'philosophy', label: 'Philosophy & history' },
];
